module.exports = __webpack_public_path__ + "img/bg12.9bf3fbc0.png";